@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../@shared/button.mixin' as *;

@layer kol-component {
	@include kol-button-styles('kol-button');
}
